import { bulkDeleteCategoriesByBusiness } from "../../../database/helpers/stock_categories";
import { bulkDeleteAttendanceByBusiness } from "../../../database/helpers/attendance";
import { bulkDeleteCustomersByBusiness } from "../../../database/helpers/customer";
import { bulkDeleteJournalsByBusiness } from "../../../database/helpers/journal";
import { bulkDeleteInvoicesByBusiness } from "../../../database/helpers/invoice";
import { bulkDeletePaymentsByBusiness } from "../../../database/helpers/payment";
import { getDifferentBusinesses } from "../../../database/helpers/business";
import { bulkDeleteStockByBusiness } from "../../../database/helpers/stock";
import { bulkDeleteStaffByBusiness } from "../../../database/helpers/staff";
import { Sync } from "../../../SyncService";

import { analytics, triggerLogEvent } from "../../../config/firebase";

export const handleDeleteBusiness = async (
  setProfileUpdted,
  setLoadBusiness,
  fromProfile,
  setLoading,
  business,
  navigate,
  user,
  I18n
) => {
  setLoadBusiness(true);
  setLoading(true);

  try {
    //Delete Payments
    bulkDeletePaymentsByBusiness(business.id)
      .then(() => {
        //Delete Stock
        bulkDeleteStockByBusiness(business.id)
          .then(() => {
            //   Delete Invoices
            bulkDeleteInvoicesByBusiness(business.id)
              .then(() => {
                // Delete Customers
                bulkDeleteCustomersByBusiness(business.id)
                  .then(() => {
                    //   Delete Journals
                    bulkDeleteJournalsByBusiness(business.id)
                      .then(() => {
                        // Delete Attendance
                        bulkDeleteAttendanceByBusiness(business.id)
                          .then(() => {
                            //   Delete Staff
                            bulkDeleteStaffByBusiness(business.id)
                              .then(() => {
                                //   Delete Categories
                                bulkDeleteCategoriesByBusiness(business.id)
                                  .then(async () => {
                                    // Switch & Delete Business
                                    let otherBusiness =
                                      await getDifferentBusinesses(business.id);

                                    otherBusiness[0].activateBusiness();
                                    localStorage.setItem(
                                      "business_id",
                                      otherBusiness[0].id
                                    );
                                    // business.deactivateBusiness()
                                    business
                                      .markAsDeleted()
                                      .then(() => {
                                        Sync(user.phone_number, navigate);
                                        setLoading(false);
                                        triggerLogEvent(
                                          analytics,
                                          "setting_business_deleted"
                                        );
                                        if (fromProfile) {
                                          setProfileUpdted(
                                            I18n.business_deleted_success
                                          );
                                          let timer = setTimeout(() => {
                                            sessionStorage.setItem("skip_pin_verify", "true");
                                            window.location.reload();
                                          }, 2000);
                                          return () => clearTimeout(timer);
                                        } else {
                                          let timer = setTimeout(() => {
                                            sessionStorage.setItem("skip_pin_verify", "true");
                                            window.location.reload();
                                          }, 2000);
                                          return () => clearTimeout(timer);
                                        }
                                      })
                                      .catch((e) => { });
                                  })
                                  .catch((e) => { });
                              })
                              .catch((e) => { });
                          })
                          .catch((e) => { });
                      })
                      .catch((e) => { });
                  })
                  .catch((e) => { });
              })
              .catch((e) => { });
          })
          .catch((e) => { });
      })
      .catch((e) => { });
  } catch (e) { }
};
